import { defineStore } from "pinia";

export const useUrlsStore = defineStore("urls", {
  state: () => ({
    baseUrl: "",
    defaults: {
      apiGetConfig: "api/webproduct/getConfig/",
      apiGetCompletePersonalization: "personalization/completePersonalization",
      apiGet: "api/webproduct/get",
      apiUpload: "api/upload",
      apiChangeOption: "api/webproduct/changeOptions",
      packingGetData: "packing/getData",
      packingGetPdf: "packing/getPdf",
      packingGetCf2: "packing/getCF2",
      checkPreflight: "api/upload/checkPreflight",
      deleteFile: "api/upload/deleteFile",
      getPersonalizeUrl: "personalization/computeUrl",
      getPdfUploadPreview: "api/upload/preview",
      connectUpload: "api/produce/connectItem", //"api/webproduct/connectProduct/index",
      mediaBaseUrl: "storage/",
      apiCustomerGalleryUrl: "api/media/gallery",
      apiDeleteImageUrl: "api/media/delete/",
      generatePdf: "",
      uploadUserPhotoUrl: "api/media",
      getResizedImageUrl: "api/media/working/",
      workingsUrl: "api/media/workings",
      rearrangePdf: "api/upload/edit",
      quotationUrl: ""
    },
    customUrls: {}
  }),

  getters: {
    getBaseUrl(state) {
      return state.baseUrl;
    },
    getUrl(state) {
      return function (url) {
        if (state.customUrls[url]) {
          return state.customUrls[url];
        }
        return state.baseUrl + state.defaults[url];
      };
    },
    getuploadUserPhotoUrl(state) {
      return this.getUrl("uploadUserPhotoUrl");
    },
    getIsQuotationUrlSet(state) {
      return state.customUrls["quotationUrl"] ? true : false;
    }
  },

  actions: {
    setCustomUrls(payload) {
      this.customUrls = payload;
    },
    setBaseUrl(payload) {
      this.baseUrl = payload;
    },
    setUrls(payload) {
      var urls = { ...payload };
      if (payload.base_url) {
        delete urls.base_url;
        this.setBaseUrl(payload.base_url);
      }
      this.setCustomUrls(urls);
    }
  }
});
